<script>
export default {
    name: "MapUserListOpener",
    emits: ['click'],
};
</script>

<template>
    <div class="map-user-list-opener" @click="() => $emit('click')">
        <div class="container">
            <div class="icon-wrapper">
                <img :src="require('@/assets/user.svg')" alt="open user list" class="icon">
            </div>
        </div>
    </div>
</template>

<style scoped>
/* overwrite browser default styles */
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

.map-user-list-opener {
    height: 40px;
    width: 40px;
    padding: 8px 12px;
    border-radius: 4px;
    background-color: #ffffff;
    box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;

    &:hover {
        cursor: pointer;
    }
}

.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    row-gap: 4px;
}

.icon {
    height: 20px;
    width: 20px;
    vertical-align: middle;
}

.user-count {
    font-size: 10px;
    color: rgba(0, 0, 0, 0.8);
    user-select: none;
}

</style>
